import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-featured-doctor',
  templateUrl: './update-featured-doctor.component.html',
  styleUrls: ['./update-featured-doctor.component.scss']
})
export class UpdateFeaturedDoctorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
